import React, { useState, useRef, useEffect } from 'react';
import './ResponsibilityDropdown.css';

const ResponsibilityDropdown = ({ responsibilities, selectedResponsibilities, onSelect, onAddNew }) => {
  const [showAddNew, setShowAddNew] = useState(false);
  const [newResponsibility, setNewResponsibility] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);

  // Filter out already selected responsibilities
  const availableResponsibilities = responsibilities.filter(
    resp => !selectedResponsibilities.includes(resp.responsibilityId)
  );

  // Filter by search query
  const filteredResponsibilities = availableResponsibilities.filter(resp => {
    if (!searchQuery.trim()) return true;
    const name = (resp.responsibilityName || '').toLowerCase();
    return name.includes(searchQuery.toLowerCase().trim());
  });

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchQuery('');
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelectResponsibility = (responsibilityId) => {
    onSelect(responsibilityId);
    setIsOpen(false);
    setSearchQuery('');
  };

  const handleAddNewResponsibility = async () => {
    if (newResponsibility.trim()) {
      await onAddNew(newResponsibility.trim());
      setNewResponsibility('');
      setShowAddNew(false);
      setIsOpen(false);
    }
  };

  return (
    <div className="responsibility-dropdown-group" ref={dropdownRef}>
      {!showAddNew ? (
        <div className="responsibility-multi-select">
          <div className="responsibility-selected-display" onClick={() => setIsOpen(!isOpen)}>
            <span className="responsibility-placeholder">Select or add a responsibility</span>
            <span className="responsibility-dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
          </div>
          {isOpen && (
            <div className="responsibility-options">
              <div className="responsibility-options-content">
                {filteredResponsibilities.length > 0 && (
                  <>
                    {filteredResponsibilities.map((resp) => (
                      <button
                        key={resp.responsibilityId}
                        className="responsibility-option"
                        onClick={() => handleSelectResponsibility(resp.responsibilityId)}
                        type="button"
                      >
                        {resp.responsibilityName}
                      </button>
                    ))}
                  </>
                )}
                <button
                  type="button"
                  className="responsibility-add-new-button"
                  onClick={() => {
                    setShowAddNew(true);
                    setIsOpen(false);
                  }}
                >
                  + Add new responsibility
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="add-responsibility-input">
          <input
            type="text"
            value={newResponsibility}
            onChange={(e) => setNewResponsibility(e.target.value)}
            placeholder="Enter responsibility name..."
            className="form-input"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddNewResponsibility();
              }
            }}
          />
          <button 
            type="button"
            className="add-responsibility-button" 
            onClick={handleAddNewResponsibility}
          >
            Add
          </button>
          <button
            type="button"
            className="cancel-button"
            onClick={() => {
              setShowAddNew(false);
              setNewResponsibility('');
            }}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default ResponsibilityDropdown;
